var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isLoading)?_c('div',{staticClass:"columns is-multiline"},_vm._l((_vm.questions),function(question,index){return _c('div',{key:index,staticClass:"column is-half"},[_c('question-box',{attrs:{"data":question}})],1)}),0):_c('loading-content')
}
var staticRenderFns = []

export { render, staticRenderFns }